import React, { useEffect } from "react";
import "./About.css"; // Reusing About CSS for consistent styling

const Purpose = () => {


    return (
        <div className="sub-page-container">
            <div className="sub-page-content">
                <h1 className="sub-page-title">Our Purpose</h1>
                <p className="sub-page-text">
                    Expanding equitable access to learning so every individual can grow,
                    advance, and elevate the quality of patient care.
                </p>
            </div>
        </div>
    );
};

export default Purpose;
